import React, { Component } from 'react';
import Router, { withRouter } from 'next/router';
import queryString from 'query-string';
import { connect } from 'react-redux';
import { TEMPLATE as PAGE_TEMPLATE } from 'constants/pages';
import { setDepartureValue } from 'state/advertsFilters/actions';
import filterAdverts from 'state/adverts/operations/filterAdverts';
import FilterByDepartureComponent from './FilterByDepartureComponent';

class FilterByDeparture extends Component {
  constructor(props) {
    super(props);

    this.handleOnChange = this.handleOnChange.bind(this);
    this.hydration = {
      required: false,
      completed: false,
    };
  }

  componentDidMount() {
    const query = queryString.parse(window.location.search);

    if (query && query.dpt) {
      const { departure } = this.props;
      this.hydration.required = true;

      if (departure && departure.options && departure.options.length > 0) {
        const departureToSelect = departure.options.find((item) => item.value === query.dpt);

        if (departureToSelect) {
          const { setDepartureValue, filterAdverts } = this.props;
          setDepartureValue(departureToSelect);
          filterAdverts();
          this.hydration.completed = true;
        }
      }
    }
  }

  componentDidUpdate() {
    if (this.hydration.required && !this.hydration.completed) {
      const query = queryString.parse(window.location.search);

      if (query && query.dpt) {
        const { departure } = this.props;
        this.hydration.required = true;

        if (departure && departure.options && departure.options.length > 0) {
          const departureToSelect = departure.options.find((item) => item.value === query.dpt);

          if (departureToSelect) {
            const { setDepartureValue, filterAdverts } = this.props;
            setDepartureValue(departureToSelect);
            filterAdverts();
            this.hydration.completed = true;
          }
        }
      }
    }
  }

  handleOnChange(value) {
    const { setDepartureValue, filterAdverts } = this.props;
    setDepartureValue(value);
    filterAdverts();

    // NOTE : CODE BELLOW IS USED TO APPEND DEPARTURE TO QUERY PARAMETER
    // let pathname = router.asPath;
    // const indexOfQuery = router.asPath.indexOf('?');

    // if (indexOfQuery !== -1) {
    //   pathname = router.asPath.slice(0, indexOfQuery);
    // }

    // const dptValue = value && value.value ? value.value : '';
    // const nextAsPath = `${pathname}?dpt=${dptValue}`;
    // Router.push(PAGE_TEMPLATE, nextAsPath, { shallow: true });
  }

  render() {
    const { departure, colors } = this.props;
    const { options, value } = departure;

    return (
      <FilterByDepartureComponent
        colors={colors}
        options={options}
        selectedOptions={value}
        onChange={this.handleOnChange}
      />
    );
  }
}

function mapStateToProps(state) {
  return {
    departure: state.advertsFilters.departure,
    colors: state.theme.colors,
  };
}

function mapDispatchToProps(dispatch) {
  return {
    setDepartureValue(value) {
      dispatch(setDepartureValue(value));
    },
    filterAdverts() {
      dispatch(filterAdverts());
    },
  };
}

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(FilterByDeparture));
